import React, {useEffect, useRef, useState} from 'react';
import './RecruitmentHomepage.css';
import {getResource, getFilteredResource} from '../../service/http-service';
import ReactPaginate from "react-paginate";
import {RecruitmentCardKam} from "./RecruitmentCardKam";
import SelectOption from "../../ui/SelectOption";

export const KamRecruitmentHomepage = () => {

    const [regular, setRegular] = useState([])
    const [filtersDto, setFiltersDto] = useState({archive: false, page: 1, count: 15})
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [cities, setCities] = useState([])
    const [employeeTypes, setEmployeeTypes] = useState([])


    useEffect (() => {
        getFilteredResource('portal_recruitment/get_filtered', filtersDto).then((data) => {
                 setRegular(data.data.content)
                 setTotalPageCount(data.data.totalPages);
            })
            getResource('cities').then((data) => {
                setCities(data.data)
                    })
        getResource('employee_types').then((data) => {
            setEmployeeTypes(data.data)
        })
    }, []);


    const getFilteredResults = () => {
        getFilteredResource('portal_recruitment/get_filtered', filtersDto).then((data) => {
            setRegular(data.data.content);
            setTotalPageCount(data.data.totalPages);
        });
    }

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setFiltersDto({...filtersDto, page : selectedPage + 1
        })};

    useEffect(() => {
        setFiltersDto({...filtersDto, page: 1 });
        getFilteredResults();
    }, [filtersDto.cityId]);

    useEffect(() => {
        setFiltersDto({...filtersDto, page: 1 });
        getFilteredResults();
    }, [filtersDto.employeeTypeId]);

    useEffect(() => {
        getFilteredResults();
    }, [totalPageCount])

    useEffect(() => {
        getFilteredResults();
    }, [filtersDto.page])

    return (
        <div className="main_container">
           <div className="inner_container">
               <div className="apply_title_container">
                   <div className="active_tab_indicator"></div>
                   <div className="title">Отворени работни позиции</div>
               </div>
               <div className="filters">
                   {(employeeTypes && employeeTypes.length > 0) &&
                       <SelectOption
                           placeholder={"Пребарај по сектор"}
                           value={filtersDto.employeeTypeId ? filtersDto.employeeTypeId : ""}
                           data={employeeTypes}
                           handleChange = {(selectedOption) => {
                               setFiltersDto({ ...filtersDto, employeeTypeId: selectedOption ? selectedOption.value : "" })}}
                       />}
                   {(cities && cities.length > 0) &&
                       <SelectOption
                           placeholder={"Пребарај по град"}
                           value={filtersDto.cityId ? filtersDto.cityId : ""}
                           data={cities}
                           handleChange = {(selectedOption) => {
                           setFiltersDto({ ...filtersDto, cityId: selectedOption ? selectedOption.value : "" })}}
                       />}
               </div>
               <div className="info_text">
                   <p>Изберете сектор и/или град за да ги пронајдете работните позиции што најмногу одговараат на вас.</p>
               </div>
               <div className="job_advertisements">
                   {(regular && regular.length > 0) && regular.map(item => <RecruitmentCardKam key={item.id} entity={item}/>)}

               </div>
               <div className="pagination mt-5">
                   <ReactPaginate
                       className="pagination"
                       nextLabel=">"
                       onPageChange={(e) => handlePageClick(e)}
                       pageRangeDisplayed={0}
                       marginPagesDisplayed={1}
                       pageCount={totalPageCount}
                       previousLabel="<"
                       pageClassName="page-item"
                       pageLinkClassName="page-link"
                       previousClassName="page-item"
                       previousLinkClassName="page-link"
                       nextClassName="page-item"
                       nextLinkClassName="page-link"
                       breakLabel="..."
                       breakClassName="page-item"
                       breakLinkClassName="page-link"
                       containerClassName="pagination"
                       activeClassName="active"
                       renderOnZeroPageCount={null}
                   />
               </div>
           </div>
          </div>
            )};




export default KamRecruitmentHomepage;